const ICON_PATHS = {
  apps: "M5 5h3v3H5V5Zm5.5 0h3v3h-3V5ZM16 5h3v3h-3V5ZM5 10.5h3v3H5v-3Zm5.5 0h3v3h-3v-3Zm5.5 0h3v3h-3v-3ZM5 16h3v3H5v-3Zm5.5 0h3v3h-3v-3Zm5.5 0h3v3h-3v-3Z",
  route:
    "M6 19a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm12-8a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM8.5 15.5c5.5 0 3-7 7-7M18 8h.01",
  refresh:
    "M20 11a8 8 0 1 0-2.34 5.66M20 5v6h-6",
  search:
    "m20 20-4.2-4.2m2.2-5.3a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0Z",
  filter: "M4 6h16M7 12h10m-7 6h4",
  orders:
    "M5 4h14v16H5V4Zm3 4h8M8 12h8M8 16h5",
  clock:
    "M12 7v5l3 2m6-2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z",
  partial:
    "M12 3a9 9 0 1 0 9 9h-9V3Zm0 0v9h9",
  sync:
    "M4 7h11l-3-3m3 3-3 3m8 7H9l3 3m-3-3 3-3",
  warning:
    "M12 9v4m0 4h.01M10.3 4.4 2.7 18a2 2 0 0 0 1.75 3h15.1a2 2 0 0 0 1.75-3L13.7 4.4a2 2 0 0 0-3.4 0Z",
  chevronLeft: "m15 18-6-6 6-6",
  chevronRight: "m9 18 6-6-6-6",
  database:
    "M4 6c0-1.66 3.58-3 8-3s8 1.34 8 3-3.58 3-8 3-8-1.34-8-3Zm0 0v6c0 1.66 3.58 3 8 3s8-1.34 8-3V6m-16 6v6c0 1.66 3.58 3 8 3s8-1.34 8-3v-6",
  check: "m5 12 4 4L19 6",
  upload: "M12 16V4m0 0L7 9m5-5 5 5M5 15v5h14v-5",
  camera: "M4 7h3l1.5-2h7L17 7h3v12H4V7Zm8 9a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
  truck:
    "M3 6h11v10H3V6Zm11 4h4l3 3v3h-7v-6ZM7 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm10 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
  document:
    "M7 3h7l4 4v14H7V3Zm7 0v5h5M10 12h5m-5 4h5",
  master:
    "M4 5h16v14H4V5Zm0 5h16M9 5v14",
  close: "m6 6 12 12M18 6 6 18",
  wallet: "M4 6h15a2 2 0 0 1 2 2v10H4a2 2 0 0 1-2-2V6Zm0 0 11-3v3m2 5h4v4h-4a2 2 0 0 1 0-4Z",
  bell: "M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9Zm-8 12h4",
  user: "M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm-7 9a7 7 0 0 1 14 0",
  map: "m3 6 6-3 6 3 6-3v15l-6 3-6-3-6 3V6Zm6-3v15m6-12v15",
  location: "M12 21s7-5.2 7-12a7 7 0 1 0-14 0c0 6.8 7 12 7 12Zm0-9a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
  info: "M12 10v7m0-10h.01m9 5a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z",
};

export function Icon({ name, size = 18 }) {
  return (
    <svg
      aria-hidden="true"
      fill="none"
      height={size}
      viewBox="0 0 24 24"
      width={size}
    >
      <path
        d={ICON_PATHS[name]}
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
      />
    </svg>
  );
}
